
































import Vue from "vue";
import iwButtonLoading from "@/shared/components/ButtonLoading.vue";
import iwPackSelector from "@/myImmoweb/modal/PackSelector.vue";
import iwBackOfficeActionReason from "@/myImmoweb/modal/BackOfficeActionReason.vue";

import { BackOfficeAction } from "@/shared/interfaces/BackOfficeAction.interface";
import { upgradeClassified } from "@/shared/scripts/BackOfficeApi";

import { mapActions, mapState } from "vuex";
import { i18n } from "@/shared/scripts/helpers/translation/i18n";

export default Vue.extend({
    components: {
        iwPackSelector: iwPackSelector,
        iwBackOfficeActionReason: iwBackOfficeActionReason,
        iwButtonLoading: iwButtonLoading,
    },

    data: function() {
        return {
            isLoading: false,
            backOfficeUpgrade: {} as BackOfficeAction,
            selectedPack: "" as string,
        };
    },

    computed: {
        ...mapState("MyClassifiedsModule", ["classifiedToUpgrade"]),

        availablePacks: function(): string[] {
            const publishedPack = this.classifiedToUpgrade?.publication.visualizationOption;

            if (publishedPack === "BASIC") {
                return ["CLASSIC", "PREMIUM"];
            }
            return ["PREMIUM"];
        }
    },

    mounted: function() {
        this.backOfficeUpgrade.visualizationOption = this.availablePacks[0];
    },

    methods: {
        ...mapActions({
            closeMasqueradeModal: "ModalModule/closeMasqueradeModal"
        }),

        selectPack: function(pack: string) {
            this.backOfficeUpgrade.visualizationOption = pack;
        },

        updateInfo: function(info: string) {
            this.backOfficeUpgrade.info = info;
        },

        upgradeClassifiedCall: function() {
            this.isLoading = true;
            upgradeClassified(this.backOfficeUpgrade).then(res => {
                this.isLoading = false;
                if (res.status === "ACTIVE") {
                    this.$emit("success");
                }
            }).catch(error => {
                this.dialog.alert(i18n.t("server_not_responding_error").toString());
                console.error(error);
                this.isLoading = false;
            });
        },
    }
});
